module.exports = __webpack_public_path__ + "static/img/3104.ee1fbb24.png";